import { cn } from '@/lib/utils';

const OPTIONS = [
  { value: 'Sale', label: 'For Sale' },
  { value: 'Rent', label: 'For Rent' },
];

/** Compact Sale / Rent segmented control wired to filters.listingType. */
export function ListingTypeToggle({ value, onChange, className }) {
  const active = value === 'Rent' ? 'Rent' : 'Sale';

  return (
    <div
      role="radiogroup"
      aria-label="Listing type"
      className={cn(
        'inline-flex shrink-0 rounded-xl border border-slate-200 bg-slate-100/80 p-0.5',
        className,
      )}
      data-testid="listing-type-toggle"
    >
      {OPTIONS.map((opt) => {
        const selected = active === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded-[10px] px-3 py-1.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
              selected
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-slate-600 hover:text-slate-900',
            )}
            data-testid={`listing-type-${opt.value.toLowerCase()}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export function getListingType(filters) {
  const raw = Array.isArray(filters?.listingType) ? filters.listingType[0] : filters?.listingType;
  return raw === 'Rent' ? 'Rent' : 'Sale';
}
